import React from "react";
import cx from "classnames";
import { useZendeskWidget } from "@tkww/orion-web-ext-zendesk/react";
import { Button } from "@xo-union/tk-component-buttons";
import BlankButton from "@xo-union/component-blank-button";
import Icon from "@xo-union/tk-component-icons";
import Spinner from "@xo-union/tk-component-spinner";
import { useThrottledState } from "../../../../../utils/useThrottledState.js";
import styles from "../../../../../css/index.css";
const ChatSection = _ref => {
  let {
    hideInMobile,
    hideInDesktop
  } = _ref;
  const [data, actions] = useZendeskWidget();
  const throttledIsLoading = useThrottledState(data.isLoading, 500);
  const handleClick = () => data.isOpen ? actions.close() : actions.open();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.chatSection, hideInDesktop && styles.hideChatInDesktop, hideInMobile && styles.hideChatInMobile)
  }, /*#__PURE__*/React.createElement(BlankButton, {
    className: styles.chatBubble,
    onClick: handleClick
  }, throttledIsLoading ? /*#__PURE__*/React.createElement(Spinner, {
    className: styles.chatSpinner,
    size: "lg"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "speech_bubble_dots",
    size: "lg"
  })), /*#__PURE__*/React.createElement(Button, {
    color: "quaternary-alternative",
    size: "md",
    onClick: handleClick,
    isLoading: throttledIsLoading,
    loadingText: "Opening Zendesk Chat"
  }, "Need help?\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.chatCta
  }, "Chat with us")));
};
export default ChatSection;